// @flow
import React from 'react';
import styled from 'styled-components';
import { colors } from 'seedling/constants';
import { rgba } from 'polished';
import $ from 'jquery';
import classNames from 'classnames';

const wrapperClassName = 'js-expandable';
const noop = () => {};
let MountedInstances = [];

const closeAllOtherInstances = instanceToRemainOpen => {
  MountedInstances.filter(
    instance => instance !== instanceToRemainOpen
  ).map(instance => instance.setState({ visible: false }));
};

type Props = {
  direction: 'bottom-right' | 'bottom-left',
  menuStyle: ?any,
  isDisabled: () => ?boolean,
  registerEvents: () => void,
  trigger: React$Node,
  render?: ({
    hide: () => void,
  }) => React$Node,
  children?: React$Node,
  onHide: () => void,
};

type State = {
  visible: boolean,
};

class ExpandableMenu extends React.Component<Props, State> {
  static defaultProps = {
    direction: 'bottom-right',
    menuStyle: {},
    isDisabled: noop,
    registerEvents: () => {},
    onHide: noop,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  changeVisibleState = (callback: () => void = noop) => {
    this.setState({ visible: !this.state.visible }, () => {
      if (!this.state.visible) {
        this.props.onHide();
      }

      callback();
    });
  };

  hide = () => {
    this.setState({ visible: false });
  };

  onClickTrigger = (e: Event) => {
    if (this.props.isDisabled()) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    this.changeVisibleState(() => {
      closeAllOtherInstances(this);
      this.props.registerEvents();
    });
  };

  onClickBody = (e: Event) => {
    const clickedOnExpandedMenu = $(e.target).parents(`.${wrapperClassName}`)
      .length;

    if (!clickedOnExpandedMenu && this.state.visible) {
      this.changeVisibleState();
    }
  };

  componentDidMount() {
    $(document.body).on('click', this.onClickBody);
    MountedInstances.push(this);
  }

  componentWillUnmount() {
    $(document.body).off('click', this.onClickBody);
    MountedInstances = MountedInstances.filter(instance => instance !== this);
  }

  renderChildren() {
    if (this.props.render) {
      return this.props.render({
        hide: this.hide,
      });
    } else {
      return this.props.children;
    }
  }

  render() {
    const { trigger, direction, menuStyle, isDisabled } = this.props;

    return (
      <Wrapper
        data-expandable-menu
        data-provides={'action'}
        data-provides-for={'expand'}
        className={classNames(wrapperClassName, {
          'js-expanded': this.state.visible,
        })}
        disabled={isDisabled()}
      >
        <div onClick={this.onClickTrigger}>{trigger}</div>
        {this.state.visible && (
          <ContentContainer
            style={menuStyle}
            direction={direction}
            className="content-container"
            onClick={(e: Event) => e.stopPropagation()}
          >
            {this.renderChildren()}
          </ContentContainer>
        )}
      </Wrapper>
    );
  }
}

export default ExpandableMenu;
export { wrapperClassName };

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  user-select: none;
  cursor: ${props => (props.disabled ? 'auto' : 'pointer')};
`;

const ContentContainer = styled.div`
  position: absolute;
  ${props => (props.direction === 'bottom-right' ? `right: 0;` : `left: 0;`)};
  top: 35px;
  min-width: 180px;
  box-sizing: border-box;
  padding: 1em 1.2em;
  background-color: white;
  text-align: left;
  z-index: 100;
  border: 1px solid ${colors.lightGrey};
  box-shadow: 0 1px 3px 0 ${rgba(0, 0, 0, 0.14)};
  border-radius: 2px;

  a + a {
    margin-top: 0.25em;
  }
`;
